import { useTranslation } from 'react-i18next'
import { CurecallButton, TrashIcon, ECurecallSize, ECurecallButtonAppearance } from '@honestica/curecall-ui'

type TDeletingNodeButtonProps = {
  onClick: (e: React.MouseEvent) => void
  ariaLabel?: string
  className?: string
}

export function DeletingNodeButton({ onClick, ariaLabel, className }: TDeletingNodeButtonProps) {
  const { t } = useTranslation()

  return (
    <CurecallButton
      ariaLabelText={ariaLabel || t('pages.configuration.followups.chatbot.node-editor.delete-node')}
      iconType={<TrashIcon />}
      appearance={ECurecallButtonAppearance.CANCEL}
      onClick={onClick}
      size={ECurecallSize.SMALL}
      className={className || 'c-text-white c-bg-grey-700 c-w-4 c-h-4 c-p-0 [&>div]:c-w-4 [&>div]:c-h-4'}
    />
  )
}
